import axios from 'axios';
import Service from '@advisor/util/Service';
import {CUSTODIAN, CUSTODIAN_MAP} from '@advisor/util/constants';

const {MS_BASE} = Service;

export default class MoveMoney {
  static fetchTransactionDetails(payload) {
    return axios.get(
      `${MS_BASE}/v1/custodian/moneyTransferRequest?clUserId=${payload.clUserId}&transferId=${payload.transferId}`
    );
  }

  static initialWithdrawalDate(payload) {
    return axios.get(`${MS_BASE}/v1/custodian/nextBusinessDate?transferDate=${payload}`);
  }

  /**
   * save Money Transfer Request
   * @param {accountNum} payload
   */
  static saveTransferRequest(payload) {
    const subResourceFilter = payload.custodian === CUSTODIAN_MAP[CUSTODIAN.TD] ? `?async=false` : ``;

    return axios.post(`${MS_BASE}/v1/custodian/moneyTransferRequest${subResourceFilter}`, payload);
  }

  static updateTransferRequest(payload) {
    const subResourceFilter = payload.custodian === CUSTODIAN_MAP[CUSTODIAN.TD] ? `?async=false` : ``;

    return axios.put(`${MS_BASE}/v1/custodian/moneyTransferRequest${subResourceFilter}`, payload);
  }

  /**
   * POST unlink the current BankAccount and link a new one for APEX
   * @param {brokerage account id} payload {“bankAccountId”:608,“custodian”:“APEX”}
   */
  static unlinkBankAccount(payload, brokerageAccountId) {
    return axios.post(`${MS_BASE}/v1/custodian/custodianAccounts/${brokerageAccountId}/bankLink`, payload);
  }
}
